var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgClipboardPlusSize16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_887_374339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 3.33334H5.16668C4.81305 3.33334 4.47392 3.47382 4.22387 3.72387C3.97382 3.97392 3.83334 4.31305 3.83334 4.66668V12.6667C3.83334 13.0203 3.97382 13.3594 4.22387 13.6095C4.47392 13.8595 4.81305 14 5.16668 14H11.8333C12.187 14 12.5261 13.8595 12.7762 13.6095C13.0262 13.3594 13.1667 13.0203 13.1667 12.6667V4.66668C13.1667 4.31305 13.0262 3.97392 12.7762 3.72387C12.5261 3.47382 12.187 3.33334 11.8333 3.33334H10.5",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.33333C6.5 2.97971 6.64048 2.64057 6.89052 2.39052C7.14057 2.14048 7.47971 2 7.83333 2H9.16667C9.52029 2 9.85943 2.14048 10.1095 2.39052C10.3595 2.64057 10.5 2.97971 10.5 3.33333C10.5 3.68696 10.3595 4.02609 10.1095 4.27614C9.85943 4.52619 9.52029 4.66667 9.16667 4.66667H7.83333C7.47971 4.66667 7.14057 4.52619 6.89052 4.27614C6.64048 4.02609 6.5 3.68696 6.5 3.33333Z",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16666 9.33334H9.83332",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8V10.6667",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_374339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgClipboardPlusSize16);
export default __webpack_public_path__ + "static/media/svg_clipboard_plus_size_16.b2e9c08c181ded5304694d02ceb3fd11.svg";
export { ForwardRef as ReactComponent };